import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { CleverComponent } from "./clever/clever.component";
import { BrowserModule } from "@angular/platform-browser";
import { MatCardModule } from "@angular/material/card";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
//import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from "@angular/material/grid-list";
import { MatDividerModule } from "@angular/material/divider";
import { MatTableModule } from "@angular/material/table";

const routes: Routes = [
  {
    path: "clever",
    component: CleverComponent,
  },
];

@NgModule({
  declarations: [CleverComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatCardModule,
    MatGridListModule,
    MatDividerModule,
    MatTableModule,
  ],
  exports: [CleverComponent],
})
export class CleverModule {
  constructor() {}
}
